export default __webpack_public_path__ + "static/media/lock.6ae273b6.svg";